// Unified config for both extension and web app
// This config works in both browser (React app) and extension contexts
// Webpack DefinePlugin injects process.env values at build time

export const config = {
    API_URL: process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== 'undefined'
        ? process.env.REACT_APP_API_URL
        : 'http://localhost:5000/api',
    
    EXTENSION_ID: process.env.REACT_APP_EXTENSION_ID && process.env.REACT_APP_EXTENSION_ID !== 'undefined'
        ? process.env.REACT_APP_EXTENSION_ID
        : 'hbamlghpcifegekbkmfeohikmldclipp',
    
    // CRITICAL: SECRET_KEY must be loaded from environment
    SECRET_KEY: process.env.REACT_APP_SECRET_KEY && process.env.REACT_APP_SECRET_KEY !== 'undefined'
        ? process.env.REACT_APP_SECRET_KEY
        : '',
    
    APP_URL: process.env.APP_URL && process.env.APP_URL !== 'undefined'
        ? process.env.APP_URL
        : 'http://localhost:3000',
    
    // Extension-specific settings with defaults
    settings: {
        autoFill: true,
        autoSubmit: false,
        autosavePrompt: true,
        passwordGeneration: {
            length: 16,
            includeUppercase: true,
            includeLowercase: true,
            includeNumbers: true,
            includeSymbols: true
        }
    }
};

